import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  height: 36px;
  padding: 0 16px;
  border-radius: 50px;
  background-color: ${({ isSelected }) => (isSelected ? '#FBDDD0' : '#f1f3f5')};
  cursor: pointer;
`

const HourFilter = ({ onClick, text, isSelected }) => {
  return (
    <Container
      onClick={onClick}
      isSelected={isSelected}
    >
      <span>{text}</span>
    </Container>
  )
}

export default HourFilter
